<template>
  <div class="row">
    <div v-if="!has_feeds" class="col-12 text-center">
      <h5 class="empty-content-margin text-center">
        You currently do not have any {{ getFeedLabel(true) }}s. Please create or import a {{ getFeedLabel(true) }} using the button above.
      </h5>
    </div>
    <template v-else>
      <div v-for="feed in feeds"
           :key="`desktop_feed_${feed.uuid}`"
           class="col-12 col-sm-6 col-md-4 col-xl-3 mb-4">
        <div class="card h-100">
          <a :href="`/podcast/${feed.uuid}/edit`">
            <img class="card-img-top" :src="feed.feed_artwork_thumbnail_url" width="100%">
          </a>
          <div class="card-body">
            <h5 class="card-title">
              {{ feed.name }}
            </h5>
            <p class="card-text">
              {{ htmlToPlainText(feed.description).slice(0, 100) }}<span v-if="feed.description && feed.description.length > 100">...</span>
            </p>
          </div>
          <div class="card-controls card-footer d-flex align-items-center justify-content-between">
            <b-dropdown split
                        block
                        variant="ss"
                        text="Manage"
                        :split-href="`/podcast/${feed.uuid}/edit`">
              <b-dropdown-item-button @click.prevent="selected_feed = feed; initQuickCreateModal(feed)">
                Add {{ getItemLabel(true) }}
              </b-dropdown-item-button>
              <b-dropdown-item-button @click.prevent="selected_feed = feed; preview()">
                Preview
              </b-dropdown-item-button>
              <b-dropdown-divider />
              <b-dropdown-group :id="`share_${feed.uuid}`" text="Sharing">
                <b-dropdown-item-button v-for="link in getPodcastShareLinks(['embed'])"
                                        :key="`podcast_share_${link.key}_${feed.uuid}`"
                                        @click="link.callback(feed)">
                  <i :class="link.icon" /> {{ link.label }}
                </b-dropdown-item-button>
              </b-dropdown-group>
              <b-dropdown-divider />
              <b-dropdown-item-button variant="ss-danger" @click="() => reloadAfter(feed, confirmDestroyFeeds)">
                <i class="flaticon2-warning" /> Delete
              </b-dropdown-item-button>
            </b-dropdown>
            <small class="card-episode-count">
              {{ feed.items_count }} <span>{{ getItemLabel(true) }}{{ feed.items_count !== 1 ? 's' : '' }}</span>
            </small>
          </div>
        </div>
      </div>
    </template>
    <item-creation-modal :preselected-feed="selected_feed" :is-episode="true" />
    <preview-modal v-if="selected_feed"
                   name="preview-feed"
                   :is-feed="true"
                   :entity="selected_feed" />
    <delete-confirm-modal name="delete-confirm"
                          :entities-to-delete="[selected_feed]"
                          entity-type="feed"
                          :callback="modalCallback">
      You are about to delete podcast "<span class="font-weight-bold">{{ selected_feed?.name }}"</span>!
    </delete-confirm-modal>
  </div>
</template>

<script>
import ItemQuickCreateMixin from 'VueMixins/ItemQuickCreateMixin';
import PreviewModal from "VueModals/PreviewModal";
import DeleteConfirmModal from 'VueModals/DeleteConfirmModal';
import { htmlToPlainText } from 'Lib/string-util';
import FeedsModalsMixin from "VueMixins/Feeds/FeedsModalsMixin";
import SocialShareMixin from "VueMixins/SocialShareMixin";

export default {
  components: { PreviewModal, DeleteConfirmModal },
  mixins: [ItemQuickCreateMixin, FeedsModalsMixin, SocialShareMixin],
  props: {
    feeds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selected_feed: {},
    };
  },
  computed: {
    has_feeds() {
      return this.feeds && this.feeds.length;
    },
  },
  async mounted() {
    if (!this.feeds || !this.feeds.length) {
      this.selected_feed = this.feeds[0];
    }
  },
  methods: {
    showShare(feed) {
      $(`#share_${feed.uuid}`).show();
    },
    async reloadAfter(feed, callback) {
      this.selected_feed = feed;
      const res = await callback(feed);
      if (res !== false) {
        this.$emit('reload');
      }
    },
    htmlToPlainText,
    preview() {
      this.$nextTick(() => {
        this.fireModal(`preview-feed`);
      });
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu>li>a {
  padding-left: 1.5rem;
}

.card-controls {
  flex-direction: column;
  align-items: stretch !important;
  gap: 0.5rem;

  .card-episode-count {
    text-align: center;
  }
}

@media screen and (min-width: 320px) {
  .card-controls {
    flex-direction: row;
    align-items: center !important;
  }
}
</style>
